import Modal from 'LuxKit/Modal/Modal'
import { useCallback, useRef, useState } from 'react'
import { useIntl } from 'react-intl'
import flightBundleGlossaryMessages from 'i18n/flightBundleGlossaryMessages'
import JourneyV2Details from '../V2/FareFamily/JourneyV2Details'
import TabButtonsGroup from 'LuxKit/Tabs/TabButtonsGroup'
import useStateWithSetters from 'hooks/useStateWithSetters'
import TabButton from 'LuxKit/Tabs/TabButton'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'

interface Props {
  departingJourney?: App.JourneyV2
  returningJourney?: App.JourneyV2
}

function CharterFlightDetailsModal({ departingJourney, returningJourney }: Props) {
  const intl = useIntl()
  const [fareRulesURL, setFareRulesURL] = useState<string | undefined>()
  const [fareRulesParams, setFareRulesParams] = useState<any | undefined>()

  const [currentTab, setCurrentTab] = useStateWithSetters(['departing', 'returning'])

  const journey = departingJourney && returningJourney ?
      (currentTab === 'departing' ? departingJourney : returningJourney) :
    departingJourney ?? returningJourney

  const modalRef = useRef<HTMLDivElement>(null)

  const onHideFareRules = useCallback(() => {
    setFareRulesURL(undefined)
    setFareRulesParams(undefined)
    modalRef.current?.scrollTo({ top: 0 })
  }, [])

  const fareRulesTitle = intl.formatMessage({
    id: 'rc7JwNhlqicj6Gc1u_na',
    defaultMessage: 'Fare Rules',
  })

  const flightDetailsTitle = intl.formatMessage(flightBundleGlossaryMessages.flightDetails)

  const departingLabel = intl.formatMessage({
    id: '0hT10wU8lFNJ5E3QC3GR',
    defaultMessage: 'Departing',
  })

  const returningLabel = intl.formatMessage({
    id: 'kwc4CO3rxcUXxvuw6Qhv',
    defaultMessage: 'Returning',
  })

  return <Modal
    title={fareRulesURL ? fareRulesTitle : flightDetailsTitle}
    onBack={fareRulesURL ? onHideFareRules : undefined}
    ref={modalRef}
  >
    <VerticalSpacer gap={20}>
      {!fareRulesURL && departingJourney && returningJourney && <TabButtonsGroup fit="grow">
        <TabButton
          size="medium"
          isActive={currentTab === 'departing'}
          onClick={setCurrentTab.departing}
        >
          {departingLabel}
        </TabButton>
        <TabButton
          size="medium"
          isActive={currentTab === 'returning'}
          onClick={setCurrentTab.returning}
        >
          {returningLabel}
        </TabButton>
      </TabButtonsGroup>}

      {journey && <JourneyV2Details
        setFareRulesURL={setFareRulesURL}
        setFareRulesParams={setFareRulesParams}
        fareRulesURL={fareRulesURL}
        fareRulesParams={fareRulesParams}
        journey={journey}
        isStandalone={false}
      />}
    </VerticalSpacer>
  </Modal>
}

export default CharterFlightDetailsModal
